import axios from 'axios';
import { getUserDataAction } from './GetUserDataSlice';
import Cookies from 'js-cookie';

const getUserData = (token) => {
  return async (dispatch) => {
    const fetchData = async () => {
      const headers = { Authorization: `Bearer ${token}` };
      const url = `${process.env.REACT_APP_DEV_URI}/v2/user/me`;
      const response = await axios.get(url, { headers });
      return response;
    };
    try {
      const result = await fetchData();
      dispatch(getUserDataAction.userDataSuccess(result.data));
      return result.data;
    } catch (e) {
      if (e?.response?.status === 401) {
        Cookies.remove('auth_token');
        Cookies.remove('refresh_token');
        window.location.pathname = '/';
      }
      dispatch(getUserDataAction.userDataFailure(e.response?.data ?? e.message));
      return null;
    }
  };
};

export default getUserData;
